import { render } from "./ClientView.vue?vue&type=template&id=15978cee&scoped=true"
import script from "./ClientView.vue?vue&type=script&lang=js"
export * from "./ClientView.vue?vue&type=script&lang=js"

import "./ClientView.vue?vue&type=style&index=0&id=15978cee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15978cee"]])

export default __exports__